import { ReactNode } from 'react';

// wrap clicked elements in this to prevent click events from propagating further
export const ClickCatcher = (props: {
  children: ReactNode;
  disabled?: boolean; // for temporarily suspending the behaviour
}) => (
  <span
    className="ClickCatcher"
    onClick={(e) => {
      if (props.disabled) {
        return;
      }

      e.stopPropagation();
      // console.debug('ClickCatcher stopped propagation of click');
    }}
    onContextMenu={(e) => {
      if (props.disabled) {
        return;
      }

      e.stopPropagation();
      // console.debug('ClickCatcher stopped propagation of context menu');
    }}
  >
    {props.children}
  </span>
);
